
import { TranslationContent } from '../types';

export const translations: Record<'pt' | 'en', TranslationContent> = {
  pt: {
    nav: {
      whatIDo: "O que faço",
      whoFor: "Para quem",
      whyMe: "Porquê eu",
      contact: "Contacto",
      openMenu: "Abrir menu de navegação",
      closeMenu: "Fechar menu de navegação",
      switchToPT: "Alterar idioma para Português",
      switchToEN: "Alterar idioma para Inglês"
    },
    hero: {
      tag: "WEB DEVELOPMENT & LEAD GEN",
      headline: "Websites focados em gerar novos contactos para o seu negócio.",
      subheadline: "Desenvolvimento de estruturas simples, rápidas e otimizadas para conversão. Focadas em resultados reais, sem complicações.",
      ctaContact: "Contacto",
      liveLeads: "Leads em tempo real",
      globalDelivery: "Entrega Global",
      directContact: "Contacto Direto"
    },
    whatIDo: {
      title: "O que faço",
      items: [
        {
          title: "Websites Profissionais",
          description: "Desenvolvimento técnico sólido com foco em performance e limpeza visual."
        },
        {
          title: "Foco em Conversão",
          description: "Estruturas desenhadas especificamente para transformar visitantes em leads qualificados."
        },
        {
          title: "Google Ads e SEO",
          description: "Otimização local para que o seu negócio seja encontrado por quem realmente procura."
        },
        {
          title: "Comunicação Direta",
          description: "Sem agências ou intermediários. Fala diretamente com quem executa o projeto."
        }
      ]
    },
    whoFor: {
      title: "Para quem é",
      subtitle: "Especialização em negócios locais que necessitam de uma presença digital validada e eficiente em múltiplos mercados.",
      niches: [
        "Contabilistas e Revisores",
        "Advogados e Solicitadores",
        "Empresas de Serviços Locais",
        "Clínicas e Profissionais de Saúde"
      ],
      markets: ["Portugal", "EUA", "Internacional"]
    },
    whyMe: {
      title: "Porquê trabalhar comigo",
      items: [
        {
          title: "Background Técnico",
          description: "Experiência sólida que garante que o seu site não só é bonito, como funciona na perfeição."
        },
        {
          title: "Simplicidade",
          description: "Processos diretos. Sem linguajar corporativo ou termos de marketing exagerados."
        },
        {
          title: "Rapidez na Execução",
          description: "Foco no que importa para colocar o seu site online e a gerar resultados rapidamente."
        }
      ]
    },
    contact: {
      title: "Vamos falar?",
      subtitle: "Se procura um website profissional focado em resultados, entre em contacto direto. Responderei o mais brevemente possível.",
      email: "geral@vitornfgoncalves.pt",
      revealEmail: "Clique para ver o email",
      emailLabel: "Email Profissional",
      quote: "O meu foco não é vender serviços de manutenção mensal ou pacotes complexos, mas sim entregar uma ferramenta de trabalho que gere leads para o seu negócio.",
      form: {
        name: "Nome",
        email: "Email",
        message: "Como posso ajudar?",
        submit: "Enviar mensagem",
        success: "Mensagem enviada com sucesso!",
        error: "Ocorreu um erro ao enviar. Tente novamente ou use o WhatsApp.",
        validationError: "Por favor, preencha todos os campos corretamente.",
        invalidEmail: "Por favor, insira um email válido.",
        requiredFields: "Todos os campos são de preenchimento obrigatório",
        successTitle: "Sucesso!",
        errorTitle: "Atenção",
        close: "Fechar",
        sending: "Enviando..."
      }
    },
    footer: {
      role: "Vitor Gonçalves",
      rights: "Todos os direitos reservados."
    }
  },
  en: {
    nav: {
      whatIDo: "What I do",
      whoFor: "For whom",
      whyMe: "Why me",
      contact: "Contact",
      openMenu: "Open navigation menu",
      closeMenu: "Close navigation menu",
      switchToPT: "Switch language to Portuguese",
      switchToEN: "Switch language to English"
    },
    hero: {
      tag: "WEB DEVELOPMENT & LEAD GEN",
      headline: "Websites focused on generating new leads for your business.",
      subheadline: "Developing simple, fast, and conversion-optimized structures. Focused on real results, no fluff.",
      ctaContact: "Contact",
      liveLeads: "Live Leads",
      globalDelivery: "Global Delivery",
      directContact: "Direct Contact"
    },
    whatIDo: {
      title: "What I do",
      items: [
        {
          title: "Professional Websites",
          description: "Solid technical development with a focus on performance and clean visuals."
        },
        {
          title: "Conversion Focus",
          description: "Structures designed specifically to turn visitors into qualified leads."
        },
        {
          title: "Google Ads & SEO",
          description: "Local optimization to ensure your business is found by those searching for you."
        },
        {
          title: "Direct Communication",
          description: "No agencies or middleman. You talk directly with the developer."
        }
      ]
    },
    whoFor: {
      title: "Ideal for",
      subtitle: "Specializing in local businesses needing a validated and efficient digital presence across international markets.",
      niches: [
        "Accountants & CPAs",
        "Lawyers & Attorneys",
        "Local Service Companies",
        "Clinics & Health Professionals"
      ],
      markets: ["Portugal", "USA", "International"]
    },
    whyMe: {
      title: "Why work with me",
      items: [
        {
          title: "Technical Background",
          description: "Solid experience ensuring your site isn't just pretty, but functions perfectly."
        },
        {
          title: "Simplicity",
          description: "Straightforward processes. No corporate jargon or marketing hype."
        },
        {
          title: "Fast Execution",
          description: "Focusing on what matters to get your site live and generating results quickly."
        }
      ]
    },
    contact: {
      title: "Let's talk?",
      subtitle: "If you're looking for a professional website focused on results, get in touch directly. I'll get back to you as soon as possible.",
      email: "geral@vitornfgoncalves.pt",
      revealEmail: "Click to reveal email",
      emailLabel: "Professional Email",
      quote: "My focus is not on selling monthly maintenance or complex packages, but on delivering a tool that generates leads for your business.",
      form: {
        name: "Name",
        email: "Email",
        message: "How can I help?",
        submit: "Send message",
        success: "Message sent successfully!",
        error: "An error occurred while sending. Try again or use WhatsApp.",
        validationError: "Please fill in all fields correctly.",
        invalidEmail: "Please enter a valid email address.",
        requiredFields: "All fields are required",
        successTitle: "Success!",
        errorTitle: "Attention",
        close: "Close",
        sending: "Sending..."
      }
    },
    footer: {
      role: "Vitor Gonçalves",
      rights: "All rights reserved."
    }
  }
};